window.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".c-team-employee").forEach(employee => {
    const item = employee.querySelector(".c-item");
    const overlay = employee.querySelector(".c-item-overlay");
    if (item && overlay) initEmployee(item, overlay);
  });
});
function initEmployee(item, overlay) {
  item.classList.add("cursor-pointer");
  item.addEventListener("click", () => {
    overlay.inert = true;
    overlay.showModal();
    overlay.inert = false;
  });
}